'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".NarvarLogo-module_narvarLogo__GibSY{height:1.5625rem;padding-top:.375rem;width:9.5625rem}";
var styles = {"narvarLogo":"NarvarLogo-module_narvarLogo__GibSY"};
styleInject["default"](css_248z, '86f197b2-7c11-46c1-8c52-d794060aa71a');

exports["default"] = styles;
